module.exports = __webpack_public_path__ + "statics/img/cate10-6@2x.8c20e64d.png";